import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import Dimensions from 'react-dimensions';
import {
	Button,
	Form,
	Input,
	Divider,
	Message
} from 'semantic-ui-react';
import Paper from 'material-ui/Paper';

import Loading from '../../components/loading';

import PreviewEmail from '../dashboard-emails-settings-page/components/preview-email';

import Validator from '../../helpers/validator';
import GA from '../../helpers/ga';

const DEFAULT_STATE = {
	errorSampleEmailRecipientEmail: false,

	errorSettingsEmailSubject: false,
	errorSettingsPrimaryTextColor: false,
	errorSettingsSecondaryTextColor: false,
	errorSettingsColorButton: false,
	errorSettingsColorBackground: false,
	errorSettingsColorContainer: false,
	errorSettingsColorBorder: false,
	errorSettingsEmailSendoutDelay: false,

	buttonSendLoading: false,
	buttonUpdateLoading: false
};

const PAGE_VIEW_NAME = '/dashboard/emails/settings/customization';

export class TemplateSettingsPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = DEFAULT_STATE;
		this.props.getAbandonedCartTemplateConnection();
	}

	componentWillUpdate (nextProps, nextState) {
		if (this.refs.alert && nextProps.meta && _.get(nextProps, 'meta.message')) {
			this.refs.alert.show(nextProps.meta);
			this.props.resetAlertMessage();
			this.setState({
				buttonSendLoading: false,
				buttonUpdateLoading: false
			});
			return;
		}
	}

	componentWillReceiveProps (nextProps) {
		if (!nextProps.templateConnection) {
			nextProps.getAbandonedCartTemplateConnection();
			return;
		}
	}

	onSubmit = (e) => {
		GA.sendEvent(PAGE_VIEW_NAME, 'click', 'UpdateButton', 1);
		const templateConnection = this.props.templateConnection;

		// Validation
		const errorSettingsEmailSubject = Validator.required(this, templateConnection, 'settings.email_subject', 'errorSettingsEmailSubject');
		const errorSettingsColorButton = Validator.colorRequired(this, templateConnection, 'settings.color_button', 'errorSettingsColorButton');
		const errorSettingsPrimaryTextColor = Validator.colorRequired(this, templateConnection, 'settings.text_color_primary', 'errorSettingsPrimaryTextColor');
		const errorSettingsSecondaryTextColor = Validator.colorRequired(this, templateConnection, 'settings.text_color_secondary', 'errorSettingsSecondaryTextColor');
		const errorSettingsColorBackground = Validator.colorRequired(this, templateConnection, 'settings.color_background', 'errorSettingsColorBackground');
		const errorSettingsColorContainer = Validator.colorRequired(this, templateConnection, 'settings.color_container', 'errorSettingsColorContainer');
		const errorSettingsColorBorder = Validator.colorRequired(this, templateConnection, 'settings.color_border', 'errorSettingsColorBorder');

		if (
			errorSettingsEmailSubject ||
			errorSettingsColorButton ||
			errorSettingsPrimaryTextColor ||
			errorSettingsSecondaryTextColor ||
			errorSettingsColorBackground ||
			errorSettingsColorContainer ||
			errorSettingsColorBorder
		) {
			return;
		}

		this.setState({
			buttonUpdateLoading: true
		});

		// Save Template Connection
		this.props.updateTemplateConnectionById(templateConnection._id, templateConnection);
	}

	onChangeField = (e, obj) => {
		if (obj.type === 'checkbox') {
			this.props.updateFormField(this.props.templateConnection, obj.name, obj.checked);
			return;
		}
		this.props.updateFormField(this.props.templateConnection, obj.name, obj.value);
	}

	render () {
		//if (!this.props.templateConnection) {
		if (false) {
			return <Loading />;
		}
		let templateConnection = {};

		// const paneHeight = this.props.containerHeight - 70; // 70px is size of first row;
		const formGroupStyle = {marginTop: '20px'};
		const formFieldStyle = {paddingTop: '8px'};

		return (
			<Paper zDepth={1} style={{marginBottom: '20px', paddingTop: '20px', minHeight: '500px'}}>
				<Form>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Email Subject'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Your custom subject of abandoned cart emails'
							name='settings.email_subject'
							value={ _.get(templateConnection, 'settings.email_subject', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsEmailSubject }
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Email Title'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Your custom title of abandoned cart emails.'
							name='settings.email_title'
							value={ _.get(templateConnection, 'settings.email_title', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsEmailSubject }
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Email Subtitle'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Your custom subtitle of abandoned cart emails'
							name='settings.email_subtitle'
							value={ _.get(templateConnection, 'settings.email_subtitle', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsEmailSubject }
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field width='4' />
						<Message info>
							<p>Use your clients' names in the email by adding [FIRST_NAME] and/or [LAST_NAME].</p>
							<p>We will replace it with their name when we send the email. Try it out! Sample client: John Doe</p>
						</Message>
					</Form.Group>
					<Divider />
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Product Quantity Text'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Text to replace the "quantity" english word'
							name='settings.product_quantity_text'
							value={ _.get(templateConnection, 'settings.product_quantity_text', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsEmailSubject }
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Product Price Text'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Text to replace the "price" english word'
							name='settings.product_price_text'
							value={ _.get(templateConnection, 'settings.product_price_text', '') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsEmailSubject }
						/>
					</Form.Group>
					<Divider />
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Primary Text Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.text_color_primary'
							value={ _.get(templateConnection, 'settings.text_color_primary', '4E4E4E') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsPrimaryTextColor }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.text_color_primary', '4E4E4E')}`}}
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Secondary Text Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.text_color_secondary'
							value={ _.get(templateConnection, 'settings.text_color_secondary', '4E4E4E') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsSecondaryTextColor }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.text_color_secondary', '4E4E4E')}`}}
						/>
					</Form.Group>
					<Divider />
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Button Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.color_button'
							value={ _.get(templateConnection, 'settings.color_button', '000000') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsColorButton }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.color_button', '000000')}`}}
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Background Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.color_background'
							value={ _.get(templateConnection, 'settings.color_background', 'FFFFFF') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsColorBackground }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.color_background', 'FFFFFF')}`}}
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Container Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.color_container'
							value={ _.get(templateConnection, 'settings.color_container', 'FFFFFF') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsColorContainer }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.color_container', 'FFFFFF')}`}}
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Border Color (HEX)'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.color_border'
							value={ _.get(templateConnection, 'settings.color_border', 'FFFFFF') }
							onChange={ this.onChangeField }
							error={ this.state.errorSettingsColorBorder }
							maxLength='6'
							icon='hashtag'
							iconPosition='left'
						/>
						<Form.Field
							style={{border: '1px solid rgba(34,36,38,.15)', borderRadius: '.28571429rem', width: '38px', height: '38px', backgroundColor: `#${_.get(templateConnection, 'settings.color_border', 'FFFFFF')}`}}
						/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
						/>
						<Form.Field
							width='6'
							control={ Button }
							color='blue'
							icon='save'
							content='UPDATE'
							onClick={ this.onSubmit }
							loading={ this.state.buttonUpdateLoading }
						/>
					</Form.Group>
				</Form>
				<br />
				<div style={{textAlign: 'center'}}>
					<div style={{width: '970px', border: '2px solid rgba(0,0,0,.25)', display: 'inline-block', margin: '5px'}}>
						<div className="bold" style={{borderBottom: '2px solid rgba(0,0,0,.25)'}}>Desktop</div>
						<PreviewEmail
							name='desktop-preview'
							width='600'
							emailTitle = { _.get(templateConnection, 'settings.email_title', '') }
							emailSubtitle = { _.get(templateConnection, 'settings.email_subtitle', '')}
							productQuantityText = { _.get(templateConnection, 'settings.product_quantity_text', '') }
							productPriceText = { _.get(templateConnection, 'settings.product_price_text', '') }
							textColorPrimary = { _.get(templateConnection, 'settings.text_color_primary', '4E4E4E') }
							textColorSecondary = { _.get(templateConnection, 'settings.text_color_secondary', '4E4E4E') }
							colorButton = { _.get(templateConnection, 'settings.color_button', '000000') }
							colorBackground = { _.get(templateConnection, 'settings.color_background', 'FFFFFF') }
							colorContainer = { _.get(templateConnection, 'settings.color_container', 'FFFFFF') }
							colorBorder = { _.get(templateConnection, 'settings.color_border', 'FFFFFF') }
						/>
					</div>
					<div style={{width: '555px', border: '2px solid rgba(0,0,0,.25)', display: 'inline-block', margin: '5px'}}>
						<div className="bold" style={{borderBottom: '2px solid rgba(0,0,0,.25)'}}>Mobile</div>
						<PreviewEmail
							name='mobile-preview'
							width="500"
							emailTitle = { _.get(templateConnection, 'settings.email_title', '') }
							emailSubtitle = { _.get(templateConnection, 'settings.email_subtitle', '')}
							productQuantityText = { _.get(templateConnection, 'settings.product_quantity_text', '') }
							productPriceText = { _.get(templateConnection, 'settings.product_price_text', '') }
							textColorPrimary = { _.get(templateConnection, 'settings.text_color_primary', '4E4E4E') }
							textColorSecondary = { _.get(templateConnection, 'settings.text_color_secondary', '4E4E4E') }
							colorButton = { _.get(templateConnection, 'settings.color_button', '000000') }
							colorBackground = { _.get(templateConnection, 'settings.color_background', 'FFFFFF') }
							colorContainer = { _.get(templateConnection, 'settings.color_container', 'FFFFFF') }
							colorBorder = { _.get(templateConnection, 'settings.color_border', 'FFFFFF') }
						/>
					</div>
				</div>
			</Paper>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {
		meta: state.dashboardEmailsSettingsReducer.meta,
		templateConnection: state.dashboardEmailsSettingsReducer.templateConnection,
		sampleEmailRecipientEmail: state.dashboardEmailsSettingsReducer.sampleEmailRecipientEmail
	};
}

export function mapsDispatchToProps ( dispatch ) {
	return {
		updateTemplateConnectionById (id, templateConnection) {
		//	dispatch( updateTemplateConnectionById (id, templateConnection) );
		},

		getAbandonedCartTemplateConnection () {
		//	dispatch( getAbandonedCartTemplateConnection () );
		},

		updateSampleEmailRecipientEmail(sampleEmailRecipientEmail) {
		//	dispatch( updateSampleEmailRecipientEmail(sampleEmailRecipientEmail) );
		},

		sendSampleEmail (recipientEmail) {
		//	dispatch( sendSampleEmail (recipientEmail) );
		},

		updateFormField (templateConnection, fieldName, fieldValue) {
		//	dispatch( updateFormField(templateConnection, fieldName, fieldValue) );
		},

		resetAlertMessage () {
		//	dispatch( resetAlertMessage() );
		},

		reset() {
		//	dispatch( reset() );
		}
	};
}

export default connect(mapsStateToProps, mapsDispatchToProps)( Dimensions()(TemplateSettingsPage) );



// WEBPACK FOOTER //
// ./src/containers/template-boarding-page/template-settings-page.js